import { object, string, number, bool } from 'yup';

export const SmsOptInSchema = object({
  enabled: bool().optional(),
  modalAppearanceDelaySeconds: number().integer().min(1).optional(),
  optInAcceptedLoyaltyEventName: string().optional(),
  optInRejectedLoyaltyEventName: string().optional(),
})
  .strict()
  .noUnknown();
